import {
  VIEW_POST_VIDEO_START,
  VIEW_POST_VIDEO_SUCCESS,
  VIEW_POST_VIDEO_FAILURE
} from "../actions/ActionConstant";

const initialState = {
  savePostVideoView: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  }
};

const PostVideoViewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_POST_VIDEO_START:
      return {
        ...state,
        savePostVideoView: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
        },
      };
    case VIEW_POST_VIDEO_SUCCESS:
      return {
        ...state,
        savePostVideoView: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case VIEW_POST_VIDEO_FAILURE:
      return {
        ...state,
        savePostVideoView: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
        },
      };

    default:
      return state;
  }
};

export default PostVideoViewsReducer;
